import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";

/**
 * Manual Routes and Pages
 */
const ListTheMaticDemoPage = React.lazy(() => import("./ListTheMaticDemoPage"));
const AddTheMaticDemoPage = React.lazy(() => import("./AddTheMaticDemoPage"));
const EditTheMaticDemoPage = React.lazy(() => import("./EditTheMaticDemoPage"));

const TheMaticDemoRoutes = () => {
  return (
    <Routes>
      <Route index exact path="/list" element={<ListTheMaticDemoPage />} />
      <Route exact path="/add" element={<AddTheMaticDemoPage />} />
      <Route exact path="/edit/:id" element={<EditTheMaticDemoPage />} />
      <Route path="*" element={<Navigate replace to="/404" />} />
    </Routes>
  );
};

export default TheMaticDemoRoutes;
